import React from 'react';
import webapi from '../../../api/webapi';
import Modal from 'react-bootstrap/Modal'
import '../../css/keyboard.min.css';
import '../../css/menu.css';
import '../../css/style.css';
import '../../css/modal1.css';

class ResultList extends React.Component {
    state = { results : [] }
    state = { word : '' }
    state = { modalshow: false};
    state = { modalHeader : '' }
    state = { modalText : '' }
    
    

    constructor(props) {
        super(props);
        this.state = { results: this.props.results };
        this.state = { modalshow: false};
    }

   
    showModal = async event => {
        event.preventDefault();
        
        
        //console.log("id:",event.target.id);
        //console.log("id:",this.state.modalshow);
        if (!this.state.modalshow)
        {
            //console.log("url:",'sentence/detail/'+event.target.id+'/null');
            const responseText= await webapi.get('sentence/detail/'+event.target.id+'/null');
            this.setState({modalText:responseText.data});
            //alert(responseText.data);
            this.setState({modalHeader: this.state.modalText.Transcription});
            //console.log("responseText:",responseText);
            this.setState({modalshow: true});
            //alert(this.state.modalText);
        }
        else
        {
            this.setState({modalshow: false});
            this.setState({modalText: '' });
        }
        
        //console.log("modalText:",this.state.modalText);
        //this.setState({modalshow: true});
    };

    CloseModal = event => {
        event.preventDefault();
        this.setState({modalshow: false});
    }

    

    render() {
        if (this.props.results) {
            if (this.props.results.length>0) {
                return (
                    <div>
                        {
                            this.props.results.map((results,i) =>{
                                return  (
                                    <div key={i} className="ui segment" dir="ltr">
                                        <form className="ui form">
                                            <div className="ui field" style={{display:'block',width:'100%',float:'left'}}>
                                                {
                                                    //TextCode,Transcription,BookCode,BookTitle,Book,Sequence--,BookCode
                                                }
                                                {
                                                    this.props.SearchtabIndex===0 
                                                    ?
                                                    (    
                                                        this.props.ResulttabIndex===0
                                                        ?
                                                        <font size="4.5" face="Ham-dib2" dir="rtl">
                                                            {results.SearchTitle}
                                                        </font>
                                                        :
                                                        [
                                                            <font size="4.5" face="Ham-dib2" dir="rtl">
                                                                {results.Word}
                                                            </font>
                                                            ,
                                                            <font size="4.5" face="Time">
                                                                {results.SearchTitle}
                                                            </font>
                                                        ]
                                                    )
                                                    :
                                                        <font size="4.5" face="Time">
                                                            {results.SearchTitle}
                                                        </font>

                                                }   
                                                <br />
                                                {
                                                    results.Books.map((bookObject ,j) => (
                                                        <div key={j} style={{float:'left',width:'100%',margin:'0px',marginBottom:'-15px'}}>
                                                            <br />
                                                            <div title={bookObject.BookTitle} style={{cursor:'pointer',float:'left'}}><font size="3">{bookObject.Book} :  </font></div>
                                                            {
                                                            // <h6>ChapterCode:{chapterObject.ChapterCode}</h6>
                                                            // <h6>ChapterTitle:{chapterObject.ChapterTitle}</h6>
                                                            // <h6>BookCode:{chapterObject.BookCode}</h6>
                                                            }
                                                            {
                                                                bookObject.Texts.map((textObject,k) => (
                                                                    (k===0) ?
                                                                    (<a href="/#" key={textObject.TextCode} id={textObject.TextCode} onClick={event => {this.showModal(event)}} style={{cursor: 'pointer'}}>{textObject.Sequence}</a>)
                                                                    :
                                                                    (<a href="/#" key={textObject.TextCode} id={textObject.TextCode} onClick={event => {this.showModal(event)}} style={{cursor: 'pointer'}}> {textObject.Sequence}</a>)
                                                                ))
                                                            }
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </form>   
                                    </div>
                                )  
                            })
                        }
                        {
                            (this.state.modalText) 
                            ?
                            (
                                <Modal
                                    show={this.state.modalshow}
                                    onHide={() => this.setState({modalshow: false})}
                                    dialogClassName="modal-90w"
                                    aria-labelledby="modal-styling-title"
                                    centered
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title id="modal-styling-title">
                                            
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Word:</div>
                                                    </td>
                                                    <td>
                                                        <div className="rtlDataPahlavi">{this.state.modalText.Word}</div>
                                                        </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Transcription:</div>
                                                    </td>
                                                    <td>
                                                        <div className="ltrData">{this.state.modalText.Transcription}</div>
                                                        </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Transliteration:</div>
                                                    </td>
                                                    <td>
                                                        <div className="ltrData">{this.state.modalText.Transliteration}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Translation1:</div>
                                                    </td>    
                                                    <td>    
                                                        <div className="ltrDataFa">{this.state.modalText.Translation}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Translation2:</div>
                                                    </td>    
                                                    <td>    
                                                        <div className="ltrDataFa">{this.state.modalText.EnTranslation}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Category:</div>
                                                    </td>    
                                                    <td>   
                                                        <div className="ltrDataFa">{this.state.modalText.Category}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Lemma:</div>
                                                    </td>    
                                                    <td>    
                                                        <div className="ltrData">{this.state.modalText.Lemma}</div>
                                                    </td>
                                                </tr>
                                                <tr> 
                                                <td>
                                                        <div className="Caption">Reference1:</div>
                                                    </td>    
                                                    <td>    
                                                        <div className="ltrData">{this.state.modalText.Reference1}</div>
                                                    </td>
                                                </tr>
                                                <tr>   
                                                    <td>
                                                        <div className="Caption">Reference2:</div>
                                                    </td>    
                                                    <td>     
                                                        <div className="ltrData">{this.state.modalText.Reference2}</div>
                                                    </td>
                                                </tr>
                                                <tr>   
                                                    <td>
                                                        <div className="Caption">Note:</div>
                                                    </td>    
                                                    <td>     
                                                        <div className="ltrData">{this.state.modalText.Note}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div className="ltrData">
                                            {
                                                this.state.modalText.Paragraph.map((ParagraphItem,k) =>{
                                                    return(
                                                        (ParagraphItem.Text===this.state.modalHeader)
                                                        ?
                                                            (<span className='HighLight' key={k}>{ParagraphItem.Text}</span>)
                                                        :
                                                            (ParagraphItem.Text)
                                                    )
                                                })
                                            }
                                        </div>
                                        <br />
                                        <div className="rtlDataFa">{this.state.modalText.ParagraphTranslation}</div>
                                        {
                                            (this.state.modalText.ParagraphTranscription!==null)
                                            ?
                                                [
                                                    <br />
                                                    ,
                                                    <div className="ltrData">{this.state.modalText.ParagraphTranscription}</div> 
                                                ]
                                            :
                                                null
                                        }
                                        {
                                            (this.state.modalText.ParagraphNote!==null)
                                            ?
                                                [
                                                    <br />
                                                    ,
                                                    <div className="rtlDataFaNote">{this.state.modalText.ParagraphNote}</div>
                                                ] 
                                            :
                                                null
                                        }
                                    </Modal.Body>
                                </Modal>
                            )
                            :
                            null
                        }
                    </div>
                )
            }
            else
            {
                return (<div>{this.props.pageData.length!==0 && this.props.pageData[0].F29903!== undefined?this.props.pageData[0].F29903:29903/*موردی یافت نشد*/}</div>)
            }
        }
        else
        {
            return (<div></div>)
        } 
    }
}


export default ResultList;